import type { ReactNode } from 'react';
import { Nav } from '../Nav';
import Footer from '../Footer';
import { useRevealObserver } from '../motion';
import '../../styles/marketing-shared.css';

type MarketingLandingShellProps = {
  children: ReactNode;
  pageClassName?: string;
};

export function MarketingLandingShell({ children, pageClassName = '' }: MarketingLandingShellProps) {
  useRevealObserver();

  return (
    <div className={`marketing-shell min-h-screen bg-surface-lowest text-on-surface ${pageClassName}`}>
      <div id="grain" aria-hidden="true" />
      <Nav />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
